import { createSlice } from "@reduxjs/toolkit";

const initialHyperParamsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  lastError: null,
  filteredEntities: "",
  hyperParamsFetchedById: "",
  hyperParamsTotalSize:0,
  page:1,
  size:10,
loader:false
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const HyperParamsManagementSlice = createSlice({
  name: "dl-hyperParams",
  initialState: initialHyperParamsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        state.entities = [];
      } else {
        state.actionsLoading = false;
        state.entities = [];
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    hyperParamsFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = action.payload.items;
      state.hyperParamsTotalSize = action.payload.total;
      state.page=action.payload.page;
      state.size=action.payload.size;
      state.totalCount = action.payload.length;
    },hyperParamsFetchedForData: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = action.payload;
      state.hyperParamsTotalSize = action.payload.total;

      state.totalCount = action.payload.length;
    },

    hyperParamsFetchedById: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.hyperParamsFetchedById = action.payload;
    },

    hyperParamsCreated: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.entities.push(action.payload);
      state.error = null;
    },

    hyperParamsUpdated: (state, action) => {
      let data = action.payload;
      state.listLoading = false;
      state.actionsLoading = false;
      state.error = null;
      state.entities = state.entities.map(entity => {
        if (entity.id === data.id) {
          return data;
        }
        return entity;
      });
    },

    clearHyperParamsById: (state, action) => {
      state.hyperParamsFetchedById = "";
    }
  }
});
